type NavigationGuard = (action: () => void) => void;

const guards = new Map<symbol, NavigationGuard>();

/** Register an active dirty editor. The most recently registered editor owns navigation. */
export function registerNavigationGuard(guard: NavigationGuard): () => void {
  const key = Symbol();
  guards.set(key, guard);
  return () => { guards.delete(key); };
}

/** Call at navigation entry points; already-guarded editor actions can navigate directly. */
export function requestGuardedNavigation(action: () => void): void {
  const guard = Array.from(guards.values()).at(-1);
  if (guard) guard(action);
  else action();
}
